import { getWidgetType } from 'components/Editor/helper/widget';
import { 
  FETCH_PAGE_REQUEST, FETCHING_PAGE_SUCCEEDED, FETCHING_PAGE_FAILED,
  SEARCH_PAGES_FOR_STORYBOARD_REQUEST, SEARCHING_PAGES_FOR_STORYBOARD_SUCCEEDED, SEARCHING_PAGES_FOR_STORYBOARD_FAILED,
  QUERY_PAGES_FOR_STORYBOARD_REQUEST, QUERY_PAGES_FOR_STORYBOARD_SUCCEEDED, QUERY_PAGES_FOR_STORYBOARD_FAILED,
  FETCH_PAGES_FOR_SELECTION_REQUEST, FETCHING_PAGES_FOR_SELECTION_SUCCEEDED, FETCHING_PAGES_FOR_SELECTION_FAILED, INVALIDATE_PAGES_FOR_SELECTION,
  CREATE_PAGE_REQUEST, CREATING_PAGE_SUCCEEDED, CREATING_PAGE_FAILED,
  CLONE_LANDING_PAGE_REQUEST, CLONE_LANDING_PAGE_SUCCEEDED, CLONE_LANDING_PAGE_FAILED,
  UPDATE_PAGE_REQUEST, UPDATING_PAGE_SUCCEEDED, UPDATING_PAGE_FAILED, 
  UPDATE_LANDING_PAGE_SETTINGS_REQUEST,
  UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED, UPDATE_LANDING_PAGE_SETTINGS_FAILED, UPDATE_PAGE_SETTINGS,
  PUBLISH_PAGE_REQUEST, PUBLISHING_PAGE_SUCCEEDED, PUBLISHING_PAGE_FAILED, 
  PUBLISH_GATING_REQUEST, PUBLISHING_GATING_SUCCEEDED, PUBLISHING_GATING_FAILED,
  CREATE_PAGE_PUBLISH_REQUEST, UPDATE_PAGE_PUBLISH_REQUEST, INVALIDATE_PAGE_PUBLISH_REQUEST,
  RESTORE_PAGE_REQUEST, RESTORING_PAGE_SUCCEEDED, RESTORING_PAGE_FAILED,
  INVALIDATE_PAGE_STATE,
  DELETE_PAGE_REQUEST, DELETING_PAGE_SUCCEEDED, DELETING_PAGE_FAILED, INVALIDATE_PAGE_DELETE, UPDATE_PAGE_VISIBILITY_REQUEST, UPDATE_PAGE_VISIBILITY_SUCCEEDED, UPDATE_PAGE_VISIBILITY_FAILED,
  RESET_GATING,
  ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED,
  AUTO_SAVE_PAGE_REQUEST, AUTO_SAVING_PAGE_SUCCEEDED, AUTO_SAVING_PAGE_FAILED,
  UPDATE_VARIABLE_MAPPINGS, REMOVE_VARIABLE_MAPPINGS,
  INVALIDATE_PAGE_QUERY, UPDATE_PAGES_TO_RENDER, INVALIDATE_PAGE_NAVIGATION, 
  FETCH_SLIDES_FOR_PAGE_REQUEST, FETCH_SLIDES_FOR_PAGE_SUCCEEDED, FETCH_SLIDES_FOR_PAGE_FAILED, 
  REARRANGE_PAGE_WIDGETS, REARRANGE_PAGE_WIDGETS_SUCCEEDED, REARRANGE_PAGE_WIDGETS_FAILED,
  UPDATE_ACTIVE_PAGE_HEALTH_CATEGORY,
  UPDATE_PAGE_HEALTH_SHOW_SEO_RECOMMENDATION,
  UPDATE_PAGE_HEALTH_PERFORMANCE_WARNINGS,
  UPDATE_PAGE_HEALTH_SEO_WARNINGS,
  UPDATE_PAGE_HEALTH_SCORE,
  UPDATE_PAGE_HEALTH_SCORE_CANONICAL,
  UPDATE_HYPERLINK_SLIDE,
  DELETE_VARIABLES_SUCCEEDED,
  EDITOR_DELETE_WIDGET,
  PAGE_SEEK_INDEXING_REQUEST,
  PAGE_SEEK_INDEXING_SUCCEEDED,
  PAGE_SEEK_INDEXING_FAILED,
  DISABLE_PAGE_SEEK_INDEXING
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  fetched: false,
  invalidated: false,
  creating: false,
  cloning: false,
  items: [],
  pagination: {},
  page: {},
  selection: {
    loading: false,
    fetched: false,
    items: [],
    pagination: {}
  },
  publish: {
    publishing: false,
    items: [],
  },
  deletion: {
    id: null,
    deleting: false,
    deleted: false,
    error: null
  },
  interactive: {
    loading: false,
    fetched: false,
    invalidated: true,
    items: []
  },
  pageQuery: {},
  spatial: {
    pagesToRender: [],
    items: [],
    hyperlinkSlide: {
      slide: "",
      page: "",
      uid: "",
      index: -1
    }
  },
  pageHealth: {
    activeCategory: 'performance',
    pageHealthScore: 0,
    widgetCount: 0,
    liveElementCount: 0,
    performanceWarnings: [],
    seoWarnings: [],
    includeSEO: false,
    canonical: '',
    mediaCache: new Map()
  },
  spatialSlides: {
    items: [],
    loading: false,
    pagination: {},
    error: null
  }
}

const initialPageState = {
  loading: false,
  item: null,
  updating: false,
  publishing: false,
  published: false,
  deleting: false,
  hiding:false,
  update: null,
  publish: null
}

export function pageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PAGE_REQUEST: {
      const { id }  = action.payload;
      const pageState = state.page[id] || initialPageState;

      var spatialPages = _.get(state, 'spatial.items', []);
      spatialPages = spatialPages.map((page) => {
        if(page.id === id) {
          return {
            ...page,
            loading: true
          }
        }

        return page;
      });

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            loading: true
          }
        },
        spatial: {
          ...state.spatial,
          items: spatialPages
        }
      }
    }

    case FETCHING_PAGE_SUCCEEDED: {
      const response  = action.payload;
      
      const id = response.id;
      const pageState = state.page[response.id] || initialPageState;

      var spatialPages = _.get(state, 'spatial.items', []);
      if (response.storyboardType === 'SPATIAL') {
        if (response.pages && _.size(spatialPages) !== _.size(response.pages)) {
          spatialPages = [...response.pages, ...spatialPages];
        }

        spatialPages = spatialPages.map((page) => {
          if (page.id === id) {
            return {
              ...page,
              loading: false,
              loaded: true
            }
          }

          return page;
        });
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: response,
            loading: false
          }
        },
        spatial: {
          ...state.spatial,
          items: spatialPages
        }
      }
    }

    case FETCHING_PAGE_FAILED: {
      const { id, error }  = action.payload;
      const pageState = state.page[id] || initialPageState;

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            loading: false,
            error: error
          }
        }
      }
    }

    case SEARCH_PAGES_FOR_STORYBOARD_REQUEST: {
      const { page } = action.payload;

      if (page === 0) {
        return {
          ...state,
          loading: true,
          fetched: false,
          items: [],
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: 0
          }
        }
      }

      return {
        ...state,
        loading: true
      }
    }

    case SEARCHING_PAGES_FOR_STORYBOARD_SUCCEEDED: {
      var items = state.items;
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = action.payload;

      if (currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records
      }

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id === y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return {
        ...state,
        loading: false,
        fetched: true,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        }
      }
    }

    case SEARCHING_PAGES_FOR_STORYBOARD_FAILED: {
      return {
        ...state,
        loading: false,
        fetched: false,
        error: action.payload
      }
    }

    case REARRANGE_PAGE_WIDGETS: {
      return {
        ...state
      }
    }

    case REARRANGE_PAGE_WIDGETS_SUCCEEDED: {
      const { response } = action.payload;

      return{
        ...state,
        items: response
      }
    }

    case REARRANGE_PAGE_WIDGETS_FAILED: {
      const { response } = action.payload;

      return{
        ...state,
        error: "Error in page rearrange"
      }
    }

    case QUERY_PAGES_FOR_STORYBOARD_REQUEST: {
      const { page } = action.payload;

      return {
        ...state,
        loading: true,
        pageQuery:{
          loading: true,
          ...state.pageQuery,
        }
      }
    }

    case QUERY_PAGES_FOR_STORYBOARD_SUCCEEDED: {
      var items = state.items;
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = action.payload;
      
      items = records;

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id === y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return {
        ...state,
        pageQuery: {
          loading: false,
          fetched: true,
          items: items,
          pagination: {
            ...state.pagination,
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount
          }
        }
      }

    }

    case QUERY_PAGES_FOR_STORYBOARD_FAILED: {
      return {
        ...state,
          pageQuery: {
          loading: false,
          fetched: false,
          error: action.payload
        }
      }
    }

    case INVALIDATE_PAGE_QUERY: {
      return {
        ...state,
          pageQuery: {
            invalidated: true
        }
      }
    }

    case FETCH_PAGES_FOR_SELECTION_REQUEST: {
      const { page } = action.payload;

      if (page === 0) {
        return {
          ...state,
          selection: {
            ...state.selection,
            loading: true,
            fetched: false,
            items: [],
            pagination: {
              currentPage: -1,
              totalPages: 1,
              recordsPerPage: 20,
              totalRecordsCount: 0
            }
          }
        }
      }

      return {
        ...state,
        selection:{
          ...state.selection,
          loading: true
        }
      }
    }

    case FETCHING_PAGES_FOR_SELECTION_SUCCEEDED: {
      var items = state.selection.items;
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = action.payload;

      if (currentPage !== 0) {
        items = [...state.selection.items, ...records];
      }
        else {
          items = records
        }
      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id === y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return {
        ...state,
        selection: {
          ...state.selection,
          loading: false,
          fetched: true,
          items: items,
          pagination: {
            ...state.selection.pagination,
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount
          }
        }
      }
    }

    case FETCHING_PAGES_FOR_SELECTION_FAILED: {
      return {
        ...state,
        selection: {
          ...state.selection,
          loading: false,
          fetched: false,
          error: action.payload
        }
      }
    }

    case INVALIDATE_PAGES_FOR_SELECTION: {
      return {
        ...state,
        selection: {
          items: [],
        }
      }
    }

    case CREATE_PAGE_REQUEST: {
      return {
        ...state,
        creating: true
      }
    } 

    case CREATING_PAGE_SUCCEEDED: {
      const response  = action.payload;
      
      const id = response.id;
      const pageState = state.page[response.id] || initialPageState;

      var pages = [...state.items, action.payload];

      return {
        ...state,
        creating: false,
        items: pages,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: response,
            loading: false
          }
        }
      }
    }

    case CREATING_PAGE_FAILED: {
      const error = action.payload;

      return {
        ...state,
        creating: false,
        error: error
      }
    }

    case CLONE_LANDING_PAGE_REQUEST: {
      return {
        ...state,
        cloning: true
      }
    }

    case CLONE_LANDING_PAGE_SUCCEEDED: {
      const response  = action.payload;
      
      const id = response.id;
      const pageState = state.page[response.id] || initialPageState;

      var pages = [...state.items, action.payload];

      return {
        ...state,
        cloning: false,
        items: pages,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: response,
            loading: false
          }
        }
      }
    }

    case CLONE_LANDING_PAGE_FAILED: {
      const error = action.payload;

      return {
        ...state,
        cloning: false,
        error: error
      }
    }

    case UPDATE_PAGE_REQUEST:
    case UPDATE_LANDING_PAGE_SETTINGS_REQUEST: {
      const { id }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            update: {
              updating: true,
              success: false
            }
          }
        }
      }
    }

    case UPDATING_PAGE_SUCCEEDED:
    case UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED: {
      const { id, response }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      var items = (state.items || []).map(item => {
        if(item.id === id) {
          return response
        }
        return item;
      })

      return {
        ...state,
        items: items,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: response,
            update: {
              updating: false,
              success: true
            }
          }
        }
      }
    }

    case UPDATING_PAGE_FAILED:
    case UPDATE_LANDING_PAGE_SETTINGS_FAILED: {
      const { id, error }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            update: {
              updating: false,
              success: false,
              error: error
            }
          }
        }
      }
    }

    case UPDATE_PAGE_SETTINGS: {
      const { id, request }  = action.payload;

      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      var pages = (state.items || []).map(item => {
        if(item.id === id) {
          return {
            ...item,
            name: request.name,
          }
        }

        return item;
      })

      return {
        ...state,
        items: pages,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: {
              ...pageState.item,
              name: request.name,
              canonical: request.alias,
              autoCreateAlias: request.autoCreateAlias,
              hidden:request.hidden,
              draft: {
                ...pageState.item.draft,
                seo: request.seo,
                social: request.social,
                twitter: request.twitter
              }
            }
          }
        }
      }
    }

    case AUTO_SAVE_PAGE_REQUEST: {
      const { id }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            autoSave: {
              updating: true,
              success: false
            }
          }
        }
      }
    }

    case AUTO_SAVING_PAGE_SUCCEEDED: {
      const { id, response }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      var items = (state.items || []).map(item => {
        if(item.id === id) {
          return response
        }
        return item;
      })

      return {
        ...state,
        items: items,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: response,
            autoSave: {
              updating: false,
              success: true
            }
          }
        }
      }
    }

    case AUTO_SAVING_PAGE_FAILED: {
      const { id, error }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            autoSave: {
              updating: false,
              success: false,
              error: error
            }
          }
        }
      }
    }

    case PUBLISH_PAGE_REQUEST: {
      const { id, callback }  = action.payload;
      
      const pageState = state.page[id] || initialPageState;

      var publishPages = (state.publish.items || []).map(data => {
        if(data.id === id) {
          return {
            ...data,
            publishing: true
          }
        }
        return data;
      })

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            id: id,
            publish: {
              publishing: true,
              success: false
            }
          }
        },
        publish: {
          ...state.publish,
          items: publishPages
        }
      }
    }

    case PUBLISHING_PAGE_SUCCEEDED: {
      const { id, response }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      var items = (state.items || []).map(item => {
        if(item.id === id) {
          return response
        }
        return item;
      })

      var publishPages = (state.publish.items || []).map(data => {
        if(data.id === id) {
          return {
            ...data,
            publishing: false,
            published:true
          }
        }
        return data;
      })

      var publishedPages = publishPages.filter((data) => data.published);
      var percentage = (publishedPages.length / publishPages.length) * 100;

      return {
        ...state,
        items: items,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: response,
            publish: {
              publishing: false,
              success: true
            }
          }
        },
        publish: {
          ...state.publish,
          items:publishPages,
          percentage: (Math.round(percentage))
        }
      }
    }

    case PUBLISHING_PAGE_FAILED: {
      const { id, error }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      var publishPages = (state.publish.items || []).map(data => {
        if(data.id === id) {
          return {
            ...data,
            error: true,
            publishing: false,
            published: false
          }
        }

        return data;
      })

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            publish: {
              publishing: false,
              success: false,
              error: error
            }
          }
        },
        publish: {
          ...state.publish,
          items:publishPages,
        }
      }
    }

    case PUBLISH_GATING_REQUEST: {
      const { id } = action.payload;

      var items = (state.publish.items || []).map(data => {
        if (data.id === id) {
          return {
            ...data,
            publishing: true
          }
        }
        return data;
      })

      return {
        ...state,
        publish: {
          ...state.publish,
          items: items
        }
      }
    }

    case PUBLISHING_GATING_SUCCEEDED: {
      const { id } = action.payload;

      var items = (state.publish.items || []).map(data => {
        if (data.id === id) {
          return {
            ...data,
            publishing: false,
            published: true
          }
        }
        return data;
      })

      var publishedPages = items.filter((data) => data.published);
      var percentage = (publishedPages.length / items.length) * 100;

      return {
        ...state,
        publish: {
          ...state.publish,
          items: items,
          percentage: (Math.round(percentage))
        }
      }
    }

    case PUBLISHING_GATING_FAILED: {
      const { id, error } = action.payload;
      
      var items = (state.publish.items || []).map(data => {
        if (data.id === id) {
          return {
            ...data,
            error: error,
            publishing: false,
            published: false
          }
        }
        return data;
      })

      return {
        ...state,
        publish: {
          ...state.publish,
          items: items
        }
      }
    }

    case CREATE_PAGE_PUBLISH_REQUEST: {
      const { items }  = action.payload;

      return {
        ...state,
        publish: {
          ...state.publish,
          publishing: true,
          items: items
        }
      }
    }

    case UPDATE_PAGE_PUBLISH_REQUEST: {
      const request = action.payload;

      return {
        ...state,
        publish: {
          ...state.publish,
          ...request
        }
      }
    }
    
    case INVALIDATE_PAGE_PUBLISH_REQUEST: {

      return {
        ...state,
        publish: {
          publishing: false,
          pages: [],
          publishingPages: []
        }
      }
    }

    case RESTORE_PAGE_REQUEST: {
      const { id }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            restore: {
              restoring: true,
              success: false
            }
          }
        }
      }
    }

    case RESTORING_PAGE_SUCCEEDED: {
      const { id, response }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: response,
            restore: {
              restoring: false,
              success: true
            }
          }
        }
      }
    }

    case RESTORING_PAGE_FAILED: {
      const { id, error }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            restore: {
              restoring: false,
              success: false,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_PAGE_STATE: {
      const id  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            update: null,
            publish: null,
            restore: null
          }
        }
      }
    }

    case INVALIDATE_PAGE_NAVIGATION: {
      const id  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            update: null,
            publish: null,
            restore: null
          }
        }
      }
    }

    case DELETE_PAGE_REQUEST: {
      const { id } = action.payload;

      return {
        ...state,
        deletion: {
          ...state.deletion,
          deleting: true,
          deleted: false,
          id: id
        }
      }
    }
  
    case DELETING_PAGE_SUCCEEDED: {
      const { id } = action.payload;

      if(id !== state.deletion.id) {
        return state;
      }

      var page = _.omit(state.page, [id]);

      var deletedIndex = (state.items || []).findIndex(item => item.id === id);

      var pages = (state.items || []).filter(item => {
        return item.id !== id;
      });

      if(deletedIndex >= pages.length) {
        deletedIndex = 0;
      }

      return {
        ...state,
        page: page,
        items: pages,
        deletion: {
          ...state.deletion,
          id: id,
          deleting: false,
          deleted: true,
          deletedIndex: deletedIndex
        }
      }
    }

    case DELETING_PAGE_FAILED: {
      const { id, error } = action.payload;

      if(id !== state.deletion.id) {
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          deletion: {
            ...state.deletion,
            deleting: false,
            deleted: false,
            error: error
          }
        }
      }
    }

    case INVALIDATE_PAGE_DELETE: {
      return {
        ...state,
        deletion: {
          id: null,
          deleting: false,
          deleted: false,
          error: null
        }
      }
    }

    case UPDATE_PAGE_VISIBILITY_REQUEST: {
      const { id, hidden } = action.payload;
      
      const pageState = state.page[id] || initialPageState;

      var pages = (state.items || []).map((page) => {
        if (page.id === id) {
          return {
            ...page,
            hidden: hidden
          }
        }
        return page
      })

      return {
        ...state,
        items: pages,
        pageHiding: true,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item:{
              ...pageState.item,
              id: id,
              hidden: hidden
            },
            hiding: true
          }
        }
      }
    }

    case UPDATE_PAGE_VISIBILITY_SUCCEEDED: {
      const { id, response } = action.payload
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      var pages = (state.items || []).map((page) => {
        if (page.id === id) {
          return {
            ...response,
          }
        }
        return page
      })

      return {
        ...state,
        pageHiding: false,
        items: pages,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item:{
              ...pageState.item,
              draft: {
                ...pageState.item.draft,
                seo: response.draft.seo,
              },
              hidden: response.hidden
            },
            hiding: false
          }
        }
      }
    }
    
    case UPDATE_PAGE_VISIBILITY_FAILED: {
      const { id, error } = action.payload;
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

    return {
        ...state,
        pageHiding: false,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            hiding: false,
            error: error
          }
        }
      }
    }

    case PAGE_SEEK_INDEXING_REQUEST: {
      const {id } = action.payload;
      const pageState = state.page[id];
      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            seekProcessing: true
          }
        }
      }
    }

    case PAGE_SEEK_INDEXING_SUCCEEDED: {
      const { id, response }  = action.payload;

      const pageState = state.page[id];
      const pageItem = pageState.item;

      if(!pageState){
        return state;
      }

      const updatedResponse = {
        ...pageItem,
        seekEnabled: response.seekEnabled,
        seekStatus: response.seekStatus
      };

      var items = (state.items || []).map(item => {
        if(item.id === id) {
          return updatedResponse;
        }
        return item;
      })

      return {
        ...state,
        items: items,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            seekProcessing: false,
            item: updatedResponse
          }
        }
      }
    }

    case PAGE_SEEK_INDEXING_FAILED: {
      const { id, error }  = action.payload;
      
      const pageState = state.page[id];
      if(!pageState){
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            error: error
          }
        }
      }
    }

    case DISABLE_PAGE_SEEK_INDEXING: {
      const { id }  = action.payload;
      const pageState = state.page[id];


      var items = (state.items || []).map(item => {
        if(item.id === id) {
          const updatedItem = {
            ...item,
            seekEnabled: false
          }
          return updatedItem;
        }
        return item;
      })

      return {
        ...state,
        items: items,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: {
              ...pageState.item,
              seekEnabled: false
            }
          }
        }
      }
    }

    case RESET_GATING: {
      const id = action.payload;

      const pageState = state.page[id];
      if (!pageState) {
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: {
              ...pageState.item,
              gatings: []
            }
          }
        }
      }
    }

    case ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED: {
      const { reference, response } = action.payload;
    
      if(reference.type !== 'page'){
        return state;
      }

      const id = reference.id;
      const pageState = state.page[id] || initialPageState;

      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: {
              ...pageState.item,
              lock: response,
            },
            loading: false
          }
        }
      }
    }

    case UPDATE_PAGES_TO_RENDER: {
      const {pages, activePage} = action.payload;

      return {
        ...state,
        spatial: {
          ...state.spatial,
          pagesToRender: pages,
          activePage: activePage
        }
      }
    }

    case FETCH_SLIDES_FOR_PAGE_REQUEST: {
      const { id, page } = action.payload;
    
      return {
        ...state,
        spatialSlides: {
          ...state.spatialSlides,
          [id]: {
            loading: true,
            items: page === 0 ? [] : state.spatialSlides[id]?.items || [],
            pagination: { currentPage: -1, totalPages: 1, recordsPerPage: 10, totalRecordsCount: 0 },
          },
        },
      };
    }
    
    case FETCH_SLIDES_FOR_PAGE_SUCCEEDED: {
      const { id, response } = action.payload;
      const { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = response;
    
      const existingSlideData = state.spatialSlides[id] || { items: [], pagination: {} };
      const items = currentPage !== 0 ? [...existingSlideData.items, ...records] : records;
    
      return {
        ...state,
        spatialSlides: {
          ...state.spatialSlides,
          [id]: {
            ...existingSlideData,
            loading: false,
            items,
            pagination: {
              currentPage,
              totalPages,
              recordsPerPage,
              totalRecordsCount,
            },
          },
        },
      };
    }
    
    case FETCH_SLIDES_FOR_PAGE_FAILED: {
      const { id, error } = action.payload;
    
      return {
        ...state,
        spatialSlides: {
          ...state.spatialSlides,
          [id]: {
            ...state.spatialSlides[id],
            loading: false,
            error,
          },
        },
      };
    }    
    case UPDATE_ACTIVE_PAGE_HEALTH_CATEGORY: {
      return {
        ...state,
        pageHealth: {
          ...state.pageHealth,
          activeCategory: action.payload
        }
      }
    }

    case UPDATE_PAGE_HEALTH_SHOW_SEO_RECOMMENDATION: {
      return {
        ...state,
        pageHealth: {
          ...state.pageHealth,
          includeSEO: !state.pageHealth.includeSEO
        }
      }
    }

    case UPDATE_PAGE_HEALTH_PERFORMANCE_WARNINGS: {
      const { performanceWarnings, widgetCount, liveElementCount, mediaCache } = action.payload;

      return {
        ...state,
        pageHealth: {
          ...state.pageHealth,
          performanceWarnings,
          widgetCount, 
          liveElementCount,
          mediaCache
        }
      }
    }

    case UPDATE_PAGE_HEALTH_SEO_WARNINGS: {
      const { seoWarnings } = action.payload;

      return {
        ...state,
        pageHealth: {
          ...state.pageHealth,
          seoWarnings,
        }
      }
    }

    case UPDATE_PAGE_HEALTH_SCORE: {
      return {
        ...state,
        pageHealth: {
          ...state.pageHealth,
          pageHealthScore: action.payload,
        }
      }
    }

    case UPDATE_PAGE_HEALTH_SCORE_CANONICAL: {
      return {
        ...state,
        pageHealth: {
          ...state.pageHealth,
          canonical: action.payload,
        }
      }
    }

    // SPATIAL HYPERLINK
    case UPDATE_HYPERLINK_SLIDE: {
      return {
        ...state,
        spatial: {
          ...state.spatial,
          hyperlinkSlide: action.payload
        }
      }
    }

    case UPDATE_VARIABLE_MAPPINGS: {
      const { id, request, deletable = [] } = action.payload;
    
      const pageState = state.page[id];
      const existingDeletedVariableMap = _.get(pageState, 'item.deletedVariableMappings') || [];
    
      const deletableSet = new Set(deletable);
    
      // Filter out deleted from existing variable mappings
      const existingVariableMap = _.get(pageState, 'item.variableMappings') || [];
      const filteredExisting = existingVariableMap.filter(item => {
        const key = item.id ?? item.uid;
        return !deletableSet.has(key);
      });
    
      // Filter out deleted from incoming request
      const filteredRequest = request.filter(item => {
        const key = item.id ?? item.uid;
        return !deletableSet.has(key);
      });
    
      // Replace existing mapping if found, else add new
      const mergedMappingsMap = new Map();
    
      filteredExisting.forEach(item => {
        const key = item.id ?? item.uid;
        mergedMappingsMap.set(key, item);
      });
    
      filteredRequest.forEach(item => {
        const key = item.id ?? item.uid;
        mergedMappingsMap.set(key, item); // this will update if key already exists
      });
    
      const updatedVariableList = Array.from(mergedMappingsMap.values());
    
      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: {
              ...pageState.item,
              variableMappings: updatedVariableList,
              deletedVariableMappings: [...existingDeletedVariableMap, ...deletable],
            }
          }
        }
      };
    }    

    case REMOVE_VARIABLE_MAPPINGS: {
      const { id, mappingId } = action.payload;
    
      const pageState = state.page[id];
    
      if (!pageState) {
        return state;
      }
    
      const variableMappings = pageState.item.variableMappings || [];
    
      const updatedMappings = variableMappings.filter(mapping => mapping.id !== mappingId);
    
      return {
        ...state,
        page: {
          ...state.page,
          [id]: {
            ...pageState,
            item: {
              ...pageState.item,
              variableMappings: updatedMappings
            }
          }
        }
      };
    }
    
    case DELETE_VARIABLES_SUCCEEDED: {
      const { response, pageId } = action.payload;
      
      const pageState = state.page[pageId];
      if (!pageState) {
        return state;
      }

      const variableMappings = pageState.item.variableMappings || [];
      const updatedMappings = variableMappings.filter(mapping => mapping.variable !== response.id);

      return {
        ...state,
        page: {
          ...state.page,
          [pageId]: {
            ...pageState,
            item: {
              ...pageState.item,
              variableMappings: updatedMappings
            }
          }
        }
      };
    }

    case EDITOR_DELETE_WIDGET: {
      const {editorSession, widgets } = action.payload;

      const pageId = editorSession.split("_")[1];
      const pageState = state.page[pageId];
      if (!pageState || !pageState.item) {
        return state;
      }

      const variableMappings = pageState.item.variableMappings || [];
      const updatedMappings = variableMappings.filter(mapping => !widgets.includes(mapping.widget));

      return {
        ...state,
        page: {
          ...state.page,
          [pageId]: {
            ...pageState,
            item: {
              ...pageState.item,
              variableMappings: updatedMappings
            }
          }
        }
      }
    }

    default:
      return state;
  }
}
